/* eslint-disable react/prop-types */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useState } from "react";
import {  Eye } from "lucide-react";
import { InfoDialog } from "@/components/dialog/info-dialog";

export function ComplementaryReportTable({ complementaryData }) {
  const [complementaryDaysDialog, setComplementaryDaysDialog] = useState(false);
  const [selectedComplementaryItem, setSelectedComplementaryItem] = useState(null);

  return (
    <div className=" w-full">
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead>Order ID</TableHead>
            <TableHead>Customer Name</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Reservation ID</TableHead>
            <TableHead>Table</TableHead>
            <TableHead>Order Type</TableHead>
            <TableHead>Items</TableHead>
            <TableHead>Total Price</TableHead>
            <TableHead>Provided By</TableHead>
            <TableHead>Date</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {complementaryData?.length == 0 && (
            <TableRow>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell colSpan="5" className="text-center text-color14">
                No discount found
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
          )}
          {complementaryData?.length > 0 &&
            complementaryData?.map((data) => (
              <TableRow key={data?.id}>
                <TableCell>{data?.id}</TableCell>
                <TableCell>{data?.customer_name || "Unknown"}</TableCell>
                <TableCell>{data?.phone || "Unknown"}</TableCell>
                <TableCell>{data?.reservation_id || "-"}</TableCell>
                <TableCell>{data?.table_no || "-"}</TableCell>
                <TableCell>
                  {data?.order_type === "pickup" && "Pickup"}
                  {data?.order_type === "in_house" && "In House"}
                  {data?.order_type === "table" && "Table"}
                  {data?.order_type === "delivery" && "Delivery"}
                  </TableCell>
                <TableCell><Eye className=" cursor-pointer" onClick={()=>{ setComplementaryDaysDialog(true); setSelectedComplementaryItem(data); }} /></TableCell>
                <TableCell>{"£" + data?.price_sum}</TableCell>
                <TableCell>{data?.provide_by}</TableCell>
                <TableCell>{data?.date}</TableCell>

              </TableRow>
            ))}
        </TableBody>
      </Table>
      <InfoDialog
        isOpen={complementaryDaysDialog}
        onClose={()=>{  setComplementaryDaysDialog(false); setSelectedComplementaryItem(null);}}
        title="Complementary Items"
        button={false}
      >
        {
          selectedComplementaryItem && selectedComplementaryItem?.items && selectedComplementaryItem?.items?.length > 0 && (
            <div className=" w-full">
              <div className=" w-full">
                <div className=" flex items-center justify-between border-b pb-1 mb-4 font-semibold">
                    <div>SL</div>
                    <div className=" w-[200px]">Item Name</div>
                    <span className=""> Quantity </span>
                    <span>Price</span>
                </div>
                {selectedComplementaryItem?.items?.map((item, index)=>(
                  <div key={index} className=" text-sm flex items-center justify-between">
                    <div className=" text-color6">{index + 1}</div>
                    <div className=" w-[210px]">{item?.item_name} {item?.variant &&<span className=" text-color6 text-xs">({item?.variant})</span>}</div>
                    <span className=" text-color8 "> x{item?.quantity} </span>
                    <span className=" w-[40px] text-color6"> £{item?.actual_price}</span>
                  </div>
                ))}
              </div>
            </div>
          )
        }
      </InfoDialog>
    </div>
  );
}
